import './App.css';
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './screens/home.js';
import Privacy from './screens/privacyPolicy.js';
import MotowayPrivacy from './screens/motowayPrivacy.js';
import MotowayEmailConfirmed from './screens/motowayEmailConfirmed.js';

const App = () => {
  return (
      <Router>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/motoway/privacy" element={<MotowayPrivacy />} />
        <Route path="/motoway/eposta-onaylandi" element={<MotowayEmailConfirmed />} />
        </Routes>
      </Router>
  );
};

export default App;